import React from 'react';
import rentalPic from '../images/dumster-rental.png'
import removalPic from '../images/junk-removal.png'
import plowPic from '../images/plow.png'
import ServiceTeaser from './ServiceTeaser';
import MiniEstimate from './MiniEstimate';
import rentalImg from "../images/rentalImg.jpeg"
const services = [
  {
    title: "Dumpster Rentals",
    image: rentalPic,
    description: "Your project, our dumpsters. Rent with us for hassle-free waste management.",
    link : "/Services"
  },{
    title: "Junk Removal",
    image: removalPic,
    description: "Decluttering made easy with our professional removal services. We do the heavy lifting for you!",
    link : "/Services#removal-service"
  },{
    title: "Snow Plowing",
    image: plowPic,
    description: "Don't let winter weather slow you down. Our plowing services ensure your driveways are always ready.",
    link : "/Services#plowing-service"
  }
  
];

function Homepage() {
  
  //create JSX elemets in an array
  const teaserList = services.map( (el, i, arr) => {
    return <ServiceTeaser title= {el.title} image= {el.image} description= {el.description} link= {el.link}/>
  });

  return (
    <>
    
    <div className= "body">
    {/* <div className= "main-images">
      <img  src="http://idealdisposal.com/MainTruck.jpg" alt="Ideal Disposal Truck" />
    </div> */}
    <div className= "main-images">

<img  src= {rentalImg} alt="Ideal Disposal Truck" />  
    </div>  
    <h1>Services</h1>

    <main id= "service-teasers">
      {teaserList}
    </main>
    <MiniEstimate/>
    </div>
    </>
    

  )
}

export default Homepage;